export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";